export default {
  type: "Feature",
  properties: {
    name: "Улаангом",
    location: [49.28054126861119, 93.03277905754612],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [90.02523154020308, 50.00028466848644],
        [90.02522617578506, 50.00028811664734],
        [90.00823974609375, 50.027152124306234],
        [90.00274658203125, 50.055375373800004],
        [90.06591796875, 50.0923932109388],
        [90.17303466796875, 50.10648772767335],
        [90.23895263671874, 50.10296448723353],
        [90.28564453124999, 50.1135334310997],
        [90.33233642578124, 50.15578588538455],
        [90.39825439453125, 50.198001033269506],
        [90.46142578125, 50.194484528931746],
        [90.48614501953125, 50.21206446065373],
        [90.48614501953125, 50.23051642081693],
        [90.5438232421875, 50.24281376239237],
        [90.59738159179686, 50.23842221881728],
        [90.64682006835938, 50.22436656050062],
        [90.67291259765625, 50.21030675884515],
        [90.7305908203125, 50.24457026654082],
        [90.70724487304688, 50.31390041107301],
        [90.77728271484375, 50.33932538402765],
        [90.79788208007812, 50.327052957438326],
        [90.82672119140625, 50.356851923320505],
        [90.85006713867188, 50.3454604086048],
        [90.87890625, 50.35422335480388],
        [90.9063720703125, 50.34721312721887],
        [90.90362548828125, 50.39451208023374],
        [90.90499877929688, 50.41289338526561],
        [90.97366333007812, 50.433017111356605],
        [91.09451293945312, 50.4373907029876],
        [91.1590576171875, 50.41989391200375],
        [91.29089355468749, 50.467994531475725],
        [91.32247924804686, 50.469742723755154],
        [91.40899658203125, 50.4478856743724],
        [91.39801025390625, 50.47498691278631],
        [91.40625, 50.48809484049477],
        [91.44332885742188, 50.49595785216966],
        [91.45431518554686, 50.54659920621419],
        [91.50375366210938, 50.56230444080573],
        [91.52984619140625, 50.582364626580485],
        [91.63421630859374, 50.58410858688503],
        [91.64657592773438, 50.58846820509024],
        [91.65069580078125, 50.641623049601776],
        [91.724853515625, 50.697327508282626],
        [91.80038452148438, 50.726024296594694],
        [91.85531616210938, 50.73558598902108],
        [91.95281982421875, 50.725154955049604],
        [92.07229614257812, 50.6964576343863],
        [92.27142333984375, 50.73819338460293],
        [92.30438232421874, 50.764259357116465],
        [92.29339599609375, 50.79725542144862],
        [92.32086181640625, 50.84237020615857],
        [92.30438232421874, 50.877044231111014],
        [92.35107421874999, 50.88397594225127],
        [92.4005126953125, 50.86317771513582],
        [92.40325927734375, 50.83196297053503],
        [92.4224853515625, 50.82155341392255],
        [92.4224853515625, 50.80419899467617],
        [92.4884033203125, 50.78510168548186],
        [92.56256103515625, 50.79725542144862],
        [92.61199951171875, 50.76078473271486],
        [92.603759765625, 50.74340774029213],
        [92.59277343749999, 50.726024296594694],
        [92.65045166015625, 50.7051556473569],
        [92.76031494140625, 50.73297844827752],
        [92.75482177734375, 50.767733723505344],
        [92.779541015625, 50.80767039437801],
        [92.90313720703125, 50.80246319809847],
        [92.92510986328125, 50.7903108164132],
        [92.95257568359375, 50.79899141148548],
        [93.0157470703125, 50.792047064406844],
        [93.021240234375, 50.71559113343383],
        [92.95806884765625, 50.666872321810715],
        [93.0047607421875, 50.60764573009064],
        [93.0487060546875, 50.61810290492478],
        [93.1365966796875, 50.583236614805905],
        [93.1365966796875, 50.60067298872855],
        [93.197021484375, 50.59892964194682],
        [93.251953125, 50.59021193935192],
        [93.2574462890625, 50.61287460808086],
        [93.31512451171875, 50.61287460808086],
        [93.33709716796875, 50.623330620643436],
        [93.35357666015625, 50.61287460808086],
        [93.416748046875, 50.62158811330541],
        [93.41125488281249, 50.63726835499671],
        [93.51837158203125, 50.61810290492478],
        [93.52111816406249, 50.60241627093303],
        [93.64471435546875, 50.60764573009064],
        [93.69415283203125, 50.58498054281802],
        [93.76007080078125, 50.59544275464843],
        [93.90289306640624, 50.59195560903164],
        [93.94958496093749, 50.581492622208735],
        [93.98529052734375, 50.60241627093303],
        [94.0374755859375, 50.59195560903164],
        [94.23797607421874, 50.59021193935192],
        [94.33135986328124, 50.543108443488386],
        [94.38079833984375, 50.226123744371364],
        [94.41375732421875, 50.20151727860476],
        [94.4659423828125, 50.199759188312086],
        [94.51263427734375, 50.17162093714734],
        [94.537353515625, 50.1135334310997],
        [94.58953857421875, 50.064191736659104],
        [94.60052490234375, 50.03773778732018],
        [94.76531982421875, 50.06066538593667],
        [94.9932861328125, 50.044793599665226],
        [95.01251220703125, 49.9812539506987],
        [95.08941650390625, 49.96182229868411],
        [95.42999267578125, 49.956521395491166],
        [95.50466537475585, 49.90668648593428],
        [95.50477266311646, 49.90668648593428],
        [95.49316406249999, 49.89109559573688],
        [95.49247741699219, 49.86498893140621],
        [95.49728393554688, 49.84728146865948],
        [95.44990539550781, 49.76618706168036],
        [95.41007995605469, 49.71648848390612],
        [95.42655944824219, 49.628059153387824],
        [95.45677185058594, 49.54481568504451],
        [95.47531127929688, 49.50202588554],
        [95.50483703613281, 49.47615556684203],
        [95.52818298339844, 49.46098385110948],
        [95.57624816894531, 49.449378780418314],
        [95.63117980957031, 49.41856738491886],
        [95.66551208496094, 49.39086527280011],
        [95.72593688964844, 49.359122687528746],
        [95.66070556640625, 49.2337407796959],
        [95.58654785156249, 49.19247423824004],
        [95.54809570312499, 49.10983779052439],
        [95.526123046875, 48.91708480384719],
        [95.50140380859374, 48.85387273165656],
        [95.44921875, 48.821332549646634],
        [95.32562255859375, 48.823140892101684],
        [95.23223876953125, 48.77067246880509],
        [95.11962890625, 48.70727541512677],
        [95.0592041015625, 48.68733411186308],
        [94.89166259765625, 48.68733411186308],
        [94.72686767578125, 48.680080770292875],
        [94.7021484375, 48.7181491602648],
        [94.537353515625, 48.71452483966839],
        [94.37530517578125, 48.73445537176822],
        [94.2132568359375, 48.777912755501845],
        [94.09790039062499, 48.79058074474321],
        [94.01275634765625, 48.741700879765396],
        [93.90838623046875, 48.70908786918211],
        [93.790283203125, 48.68733411186308],
        [93.71063232421875, 48.65468584817256],
        [93.67767333984375, 48.600225060468915],
        [93.66668701171875, 48.531157010976706],
        [93.60076904296875, 48.515694668649466],
        [93.57330322265625, 48.510236244324055],
        [93.50738525390625, 48.48475582205773],
        [93.45108032226561, 48.449243890328724],
        [93.42950463294981, 48.42428816283862],
        [93.42950463294981, 48.42429528259198],
        [93.37177276611328, 48.43284538647477],
        [93.3343505859375, 48.43990650238739],
        [93.3120346069336, 48.447649823664435],
        [93.27323913574219, 48.463815894066066],
        [93.25675964355469, 48.47610776896956],
        [93.22071075439453, 48.51774142617034],
        [93.19015502929688, 48.57183678756225],
        [93.16852569580078, 48.59409454371403],
        [93.15067291259766, 48.60703587322351],
        [93.12835693359375, 48.61861214713695],
        [93.08269500732422, 48.63109338958398],
        [93.05591583251953, 48.63563125791999],
        [93.0270767211914, 48.63676566123227],
        [92.99892425537108, 48.635404374196476],
        [92.97351837158203, 48.63063958030254],
        [92.96012878417969, 48.62587433642767],
        [92.94158935546875, 48.61588855676401],
        [92.91275024414061, 48.590007119230734],
        [92.88768768310547, 48.57342695234659],
        [92.86571502685545, 48.564339622814806],
        [92.8231430053711, 48.557295819191374],
        [92.7685546875, 48.56024979174331],
        [92.64907836914062, 48.59568400838304],
        [92.59277343749999, 48.60567378414743],
        [92.47329711914062, 48.62020084032983],
        [92.36480712890625, 48.62383195130112],
        [92.23297119140625, 48.62110864256238],
        [92.17117309570312, 48.748945343432936],
        [92.15194702148438, 48.77157756174562],
        [92.12310791015625, 48.78243740444988],
        [92.08053588867188, 48.78243740444988],
        [92.03521728515625, 48.77881771792104],
        [91.99264526367186, 48.783342285295475],
        [91.95968627929688, 48.8032455364465],
        [91.94732666015625, 48.827661462789415],
        [91.93359375, 48.89812957181126],
        [91.93634033203125, 48.935130721045326],
        [91.94183349609375, 48.96939999849952],
        [91.82647705078125, 48.96128571799032],
        [91.73171997070312, 48.943249256234296],
        [91.66305541992188, 48.915279853443806],
        [91.59576416015625, 48.8583905296204],
        [91.549072265625, 48.80686346108517],
        [91.45156860351562, 48.738983936650705],
        [91.33827209472655, 48.671855747342164],
        [91.33822917938232, 48.671919512374565],
        [91.31977558135986, 48.77369880939393],
        [91.2744140625, 48.8737479930069],
        [91.20849609375, 48.942347261978476],
        [91.11785888671875, 48.97661158387714],
        [91.02447509765625, 49.04506962208049],
        [91.00250244140624, 49.09904896047899],
        [90.9393310546875, 49.1888842152458],
        [90.8953857421875, 49.28393181795616],
        [90.81298828125, 49.30721745093609],
        [90.74432373046875, 49.30005381244688],
        [90.6646728515625, 49.33407182046059],
        [90.62072753906249, 49.40203735979645],
        [90.59051513671875, 49.42884000063522],
        [90.59051513671875, 49.47169378524674],
        [90.5108642578125, 49.5822260446217],
        [90.40924072265625, 49.648069803718805],
        [90.3021240234375, 49.692508478893274],
        [90.21697998046875, 49.742231602580716],
        [90.16754150390625, 49.807859081298325],
        [90.12908935546874, 49.917630270866894],
        [90.07965087890625, 49.97418880321091],
        [90.04600524902344, 49.983461596534674],
        [90.02523154020308, 50.00028466848644],
      ],
    ],
  },
};
